
import React from 'react';
import { PlaceContent } from './PlaceContent';
import { ResponsiveContainer } from '@/components/ui/responsive-wrapper';

interface PlaceContentWrapperProps {
  id: string;
  place: any;
  editedPlace: any;
  isEditing: boolean;
  isOwner: boolean;
  isLoggedIn: boolean;
  comments: any[];
  onInputChange: (field: string, value: any) => void;
  onCommentSubmit: (content: string) => void;
  onCommentUpdate: (commentId: string, content: string) => void;
  onCommentDelete: (commentId: string) => void;
  isSubmitting: boolean;
}

export function PlaceContentWrapper({
  id,
  place,
  editedPlace,
  isEditing,
  isOwner,
  isLoggedIn,
  comments,
  onInputChange,
  onCommentSubmit,
  onCommentUpdate,
  onCommentDelete,
  isSubmitting
}: PlaceContentWrapperProps) {
  return (
    <ResponsiveContainer className="py-4 sm:py-6 md:py-8">
      <PlaceContent
        id={id}
        place={place}
        editedPlace={editedPlace}
        isEditing={isEditing}
        isOwner={isOwner}
        isLoggedIn={isLoggedIn}
        comments={comments}
        onInputChange={onInputChange}
        onCommentSubmit={onCommentSubmit}
        onCommentUpdate={onCommentUpdate}
        onCommentDelete={onCommentDelete}
        isSubmitting={isSubmitting}
      />
    </ResponsiveContainer>
  );
}
